import { colors, StapleTable, StapleTableCell } from '@insurancemenu/imenu-components-lib';
import styled from 'styled-components';

export const StapleTableStyled = styled(StapleTable)`
  width: max(100%, 98rem);
`;

export const ActionCellStyled = styled(StapleTableCell)`
  text-align: right;
`;

export const ProductLineItemsListStyled = styled.ul`
  display: inline-flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.5rem 1rem;
  margin: 0;
  padding: 0;
  list-style: none;
`;

export const ProductLineItemStyled = styled.li<{ $isValid: boolean }>`
  position: relative;
  padding-left: 1.5rem;
  color: ${({ $isValid }): string => ($isValid ? '' : colors.red[600])};

  &::before {
    content: '•';
    position: absolute;
    left: 0;
  }
`;

export const TooltipLabelStyled = styled.span`
  max-width: 60rem;
  white-space: wrap;
  padding: 0;
  margin: 0;
`;
